import { Inject, useCore } from '..'
import { TranslationEvents } from '../translation'
import type { SystemEnvironment, LogcomexSession, ExtLinkCollection } from './integration.interface'

export class Integration {
  private _env: SystemEnvironment
  private _globalLinks!: ExtLinkCollection
  private readonly _session!: LogcomexSession

  constructor (env: SystemEnvironment) {
    this._env = env

    const session = localStorage.getItem('session')
    if (session) this._session = JSON.parse(session)
  }

  public loader() {
    useCore().event.subscribe(TranslationEvents.OnLocaleChange, () => {
      this.setGlobalLinks()
    })

    this.setGlobalLinks()
  }

  public get env (): SystemEnvironment {
    return this._env
  }

  public set env (environment: SystemEnvironment) {
    this._env = environment
  }

  public get session (): LogcomexSession {
    return this._session
  }

  private setGlobalLinks (): void {
    const token = localStorage.getItem('token') || ''
    // @TODO: precisa implementar um mecanismo de captura de cookies para colocar o real valor no attributo: cookiesHasBeenAccepted
    const queryParamsDefault = `?token=${token}&email=${this.session?.user?.email}&cookiesHasBeenAccepted=true`

    const currentLanguage = useCore().translation.currentLanguage

    this._globalLinks = {
      homol: {
        profile: 'https://plataforma.homol.logcomex.io/profile/',
        settings: `https://sistema.homol.logcomex.io/#/empresa${queryParamsDefault}`,
        certificates: 'https://plataforma.homol.logcomex.io/certificates/',
        termsOfUse: currentLanguage === 'pt-br' ? 'https://www.logcomex.com/terms' : 'https://en.logcomex.com/terms',
        consumptionReport: `https://sistema.homol.logcomex.io/#/relatorio-consumo${queryParamsDefault}`,
        accessReport: `https://sistema.homol.logcomex.io/#/relatorio-acesso${queryParamsDefault}`,
        exit: 'https://plataforma.homol.logcomex.io/logout/'
      },
      production: {
        profile: 'https://plataforma.logcomex.io/profile/',
        settings: `https://sistema.logcomex.io/#/empresa${queryParamsDefault}`,
        certificates: 'https://plataforma.logcomex.io/certificates/',
        termsOfUse: currentLanguage === 'pt-br' ? 'https://www.logcomex.com/terms' : 'https://en.logcomex.com/terms',
        consumptionReport: `https://sistema.logcomex.io/#/relatorio-consumo${queryParamsDefault}`,
        accessReport: `https://sistema.logcomex.io/#/relatorio-acesso${queryParamsDefault}`,
        exit: 'https://plataforma.logcomex.io/logout/'
      }
    }
  }

  public getGlobalLink (slug: string): string {
    return this._globalLinks[this._env][slug] || ''
  }
}
